module.exports = __webpack_public_path__ + "source/img/robot-happy.6c2a9b40.png";